const SAUNA_ROOT_ROUTE = '/my-home/sauna' as const;
const SAUNA_RESERVATION_ROUTE = `${SAUNA_ROOT_ROUTE}/:id` as const;

export const SAUNA_ROUTES = {
  SAUNA_PAGE: SAUNA_ROOT_ROUTE,
  SAUNA_RESERVATION_CALENDAR: `${SAUNA_RESERVATION_ROUTE}/book`,
  SAUNA_RESERVATION_CONFIRM: `${SAUNA_RESERVATION_ROUTE}/book/confirm`,
  SAUNA_RESERVATION_EDIT_CALENDAR: `${SAUNA_RESERVATION_ROUTE}/edit/:reservationId`,
  SAUNA_RESERVATION_EDIT_CONFIRM: `${SAUNA_RESERVATION_ROUTE}/edit/:reservationId/confirm`,
} as const;

export const MAX_SAUNA_SHIFTS = 1;
